module.exports = __webpack_public_path__ + "static/media/face-happy-filled.e57247fd.svg";